module.exports = __webpack_public_path__ + "static/img/app_ios_phone_mobile.4aef79c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/appRecommend/app_ios_phone_mobile.png
// module id = Z/Oj
// module chunks = 2